import React from "react";
import { Link as RouterLink, useParams } from "react-router-dom";
import { Box, Breadcrumbs, Button, Stack, Typography } from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { NEUTRAL } from "../../styles/brandTokens";
import {
  HELP_CENTER_GUIDE_BODIES,
  HELP_CENTER_GUIDE_METAS,
} from "../../data/helpCenterGuides";

const HelpCenterGuideArticle: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const meta = slug ? HELP_CENTER_GUIDE_METAS.find((g) => g.slug === slug) : undefined;
  const body = slug ? HELP_CENTER_GUIDE_BODIES[slug] : null;

  if (!meta || !body) {
    return (
      <Box sx={{ p: 4, maxWidth: 720, mx: "auto" }}>
        <Typography sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 18, fontWeight: 700, mb: 1 }}>
          Guide not found
        </Typography>
        <Button component={RouterLink} to="/help-center/guides" startIcon={<ArrowBackRoundedIcon />}>
          Back to guides
        </Button>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100%",
        background: NEUTRAL.page,
        pb: 6,
      }}
    >
      <Box sx={{ maxWidth: 720, mx: "auto", px: { xs: 2, sm: 3 }, pt: { xs: 2, md: 3 }, pb: 1 }}>
        <Breadcrumbs sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, mb: 2, color: "#64748b" }}>
          <RouterLink
            to="/help-center/guides"
            style={{ color: "#705d4a", textDecoration: "none", fontWeight: 600 }}
          >
            Guides
          </RouterLink>
          <Typography color="text.primary" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13 }}>
            {meta.title}
          </Typography>
        </Breadcrumbs>

        <Typography
          sx={{
            fontFamily: "var(--theo-font-sans)",
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            color: "#705d4a",
            mb: 1,
          }}
        >
          {meta.category}
        </Typography>
        <Typography
          component="h1"
          sx={{
            fontFamily: "var(--theo-font-sans)",
            fontSize: { xs: 26, md: 32 },
            fontWeight: 700,
            letterSpacing: "-0.02em",
            color: "#0f172a",
            mb: 1,
          }}
        >
          {meta.title}
        </Typography>
        <Typography sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 16, color: "#64748b", lineHeight: 1.6, mb: 3 }}>
          {meta.description}
        </Typography>

        <Box
          sx={{
            background: "#fff",
            border: "1px solid #f0f0f0",
            borderRadius: 2,
            p: { xs: 2.5, sm: 3 },
          }}
        >
          {body}
        </Box>

        <Stack direction="row" sx={{ mt: 3 }}>
          <Button
            component={RouterLink}
            to="/help-center/guides"
            variant="outlined"
            startIcon={<ArrowBackRoundedIcon />}
            sx={{
              fontFamily: "var(--theo-font-sans)",
              fontWeight: 600,
              borderColor: "#e2e8f0",
              color: "#334155",
              "&:hover": { borderColor: "#705d4a", color: "#705d4a" },
            }}
          >
            All guides
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

export default HelpCenterGuideArticle;
